// import runtimeEnv from '@mars/heroku-js-runtime-env';

const env = process.env; // runtimeEnv();

window.General = {};

window.General.IS_DEBUG = env.REACT_APP_IS_DEBUG;

window.General.WebsiteNakedDomain = env.REACT_APP_WEBSITE_NAKED_DOMAIN

window.General.ClientDashboardUrl = "http://dashboard." + window.General.WebsiteNakedDomain

window.General.ApplicationNakedDomain = env.REACT_APP_APPLICATION_NAKED_DOMAIN

window.General.ApplicationUrl = `https://${window.General.ApplicationNakedDomain}`

window.General.TestFunnelUrl = env.REACT_APP_TEST_FUNNEL_URL

export const ccDevicePreviewDockPositionSessionKey = "ccDevicePreviewDockPosition"

export const ccCurrentSelectedPreviewDevice = "ccCurrentSelectedPreviewDevice"

export const storefrontUrlSubString = "storefront.checkoutchamp.com"

export const localhostUrlSubString = "localhost:"
